import JSON5 from 'process-js-objects'
import 'www/vue_components/common/LpuServices/components'
import ScheduleVue from 'www/modules/Schedule/classes/ScheduleVue'
import { SCHEDULE_EVENTS } from 'www/modules/Schedule/constants'
import { LPU_SERVICES_EVENTS } from 'www/vue_components/common/LpuServices/constants'

import {
  getObjectQueryParams,
  dispatchCustomEventGlobally,
} from 'www/utils'

import { AppointmentModules } from 'www/modules/appointment-modules'
import { handleSuccessRequestSchedule } from 'www/vue_components/common/LpuServices/functions'
import addListenerToggleCalendar from 'www/doctors.blocks/common/b-lpu-services/functions/addListenerToggleCalendar'
import renderSchedule from 'www/doctors.blocks/common/b-lpu-services/functions/renderSchedule'
import isHtmlElement from 'www/doctors.blocks/common/b-lpu-services/functions/isHtmlElement'
import getInvasiveServiceInfoInstance from 'www/doctors.blocks/common/b-lpu-services/functions/getInvasiveServiceInfoInstance'
import useInvasiveServiceInfoStore from 'src/components/common/InvasiveServiceInfo/stores/useInvasiveServiceInfoStore'

const componentInstance = getInvasiveServiceInfoInstance()

let documentEventClick: MouseEvent | null = null

function handleRedirectAppointment() {
  /**
   * Функция срабатывает не только на странице клиники, но и на странице цен клиники. На странице цен - обработчик находится во Vue компоненте.
   * Поэтому во время вызова функции documentEventClick имеет пустой {}.
   * Если объект пуст - функция не должна срабатывать - Vue обработчик занимается обработкой редиректа.
   * Эта функция должна работать только на странице клиники.
   */
  if (!documentEventClick?.target || !('closest' in documentEventClick.target)) {
    return
  }

  const pricePrgButton = (documentEventClick.target as HTMLElement).closest('button.b-lpu-services__price')

  if (!pricePrgButton) {
    return
  }

  const prgInputUrl = pricePrgButton.closest('form.b-prg')?.querySelector<HTMLInputElement>('[name="url"]')
  const redirectUrl = new URL(decodeURIComponent(prgInputUrl?.value || ''), window.location.origin)
  const queryParamsObject = getObjectQueryParams(redirectUrl.search)
  const appointmentMethods = new AppointmentModules()

  const appointmentData: Record<string, string | undefined> = queryParamsObject
    ? {
      lpu: queryParamsObject.lpu,
      source: queryParamsObject.source,
      misServiceId: queryParamsObject.service,
    }
    : {}

  const serviceDataJson = pricePrgButton.querySelector('[data-service-data]')
    ?.getAttribute('data-service-data')
  const serviceData = serviceDataJson
    ? JSON5.parse(serviceDataJson)
    : null

  if (
    serviceData && (
      serviceData.allowTreatmentReferral
      || (serviceData.requiresPrimaryConsultation && serviceData.hasPrimaryConsultationDoctors)
    )
  ) {
    documentEventClick.preventDefault()

    const invasiveServiceInfoStore = useInvasiveServiceInfoStore()

    invasiveServiceInfoStore.openInfoModal({
      allowTreatmentReferral: serviceData.allowTreatmentReferral,
      requiresPrimaryConsultation: serviceData.requiresPrimaryConsultation,
      hasPrimaryConsultationDoctors: serviceData.hasPrimaryConsultationDoctors,
      doctorSpecialities: serviceData.doctorSpecialities,
      townTranslit: serviceData.townTranslit,
      handleConfirmReferral: () => {
        appointmentData.byReferral = 'true'
        appointmentMethods.redirectToNewAppointmentClinic(appointmentData)
      },
      handleAppointment: () => {
        appointmentMethods.redirectToNewAppointmentClinic(appointmentData)
      },
    })

    return
  }

  appointmentMethods.redirectToNewAppointmentClinic(appointmentData)
}

function updateFilterOnlineState({ target }: Event) {
  if (isHtmlElement(target) && target.closest('.lpu-services__show-all')) {
    dispatchCustomEventGlobally(LPU_SERVICES_EVENTS.switchOnline)
  }
}

if (componentInstance) {
  document.addEventListener('click', event => {
    documentEventClick = event // Для реализации расписания необходим target события. Чтобы не передавать event из функции в функцию используется глобальная переменная на уровне модуля

    if (!renderSchedule(event)) {
      handleRedirectAppointment()
    }
  })
}

document.addEventListener('click', updateFilterOnlineState)

addListenerToggleCalendar() // Добавление обработчика для показа/скрытия расписания

new ScheduleVue({ namespace: 'lpu-price-schedule' })

// @ts-ignore
window.addEventListener(SCHEDULE_EVENTS.renderSuccess, handleSuccessRequestSchedule) // Срабатывает в случае успешного рендера расписания
window.addEventListener(SCHEDULE_EVENTS.redirectSynonymPrice, handleRedirectAppointment) // Срабатывает в случае неудачного рендера расписания(их отсутствие, ошибка запроса и тд)
